
import { DecisionTimeFrame } from '../../api/models/decisionTimeFrame';
import {
  createAction,
  createActionWithPayload,
  IAction,
  IActionWithPayload,
} from '../utils';

const ACTION_LOAD_DECISIONTIMEFRAME_REQUEST = 'ENTITIES/LOAD_DECISIONTIMEFRAME_REQUEST';
const ACTION_LOAD_DECISIONTIMEFRAME_SUCCESS = 'INTENT/LOAD_DECISIONTIMEFRAME_SUCCESS';
const ACTION_LOAD_DECISIONTIMEFRAME_ERROR = 'INTENT/LOAD_DECISIONTIMEFRAME_ERROR';

export interface DecisionTimeFrameState {
  decisionTimeFrame: DecisionTimeFrame[];
  isLoading?: boolean;
  isLoaded?: boolean;
}

const initialState: DecisionTimeFrameState = {
  decisionTimeFrame: [],
  isLoaded: false,
  isLoading: false,
};

type DecisionTimeFrameRequestActionType = IAction<typeof ACTION_LOAD_DECISIONTIMEFRAME_REQUEST>;

type DecisionTimeFrameSuccessActionType = IActionWithPayload<
  typeof ACTION_LOAD_DECISIONTIMEFRAME_SUCCESS,
  DecisionTimeFrame[]
>;

type DecisionTimeFrameErrorActionType = IAction<typeof ACTION_LOAD_DECISIONTIMEFRAME_ERROR>;

type Actions =
  | DecisionTimeFrameRequestActionType
  | DecisionTimeFrameSuccessActionType
  | DecisionTimeFrameErrorActionType;

export const loadDecisionTimeFrameRequestAction = (): DecisionTimeFrameRequestActionType => {
  return createAction(ACTION_LOAD_DECISIONTIMEFRAME_REQUEST);
};

export const loadDecisionTimeFrameSuccessAction = (
  data: DecisionTimeFrame[]
): DecisionTimeFrameSuccessActionType => {
  return createActionWithPayload(ACTION_LOAD_DECISIONTIMEFRAME_SUCCESS, data);
};

export const loadDecisionTimeFrameErrorAction = (): DecisionTimeFrameErrorActionType => {
  return createAction(ACTION_LOAD_DECISIONTIMEFRAME_ERROR);
};

// reducer
export const decisionTimeFrameReducer = (
  state: DecisionTimeFrameState = initialState,
  action: Actions
): DecisionTimeFrameState => {
  switch (action.type) {
    case ACTION_LOAD_DECISIONTIMEFRAME_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    case ACTION_LOAD_DECISIONTIMEFRAME_ERROR:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case ACTION_LOAD_DECISIONTIMEFRAME_SUCCESS:
      return {
        ...state,
        decisionTimeFrame: action.payload,
        isLoading: false,
        isLoaded: true,
      };
    default:
      return state;
  }
};
